import { BrowserRouter, Route, Switch } from 'react-router-dom';
import Header from './components/Header';
import Home from './pages/Home';
import Filme from './pages/Filme';
import Favoritos from './pages/Favoritos';
import NotFound from './pages/NotFound';

const Routes = () => {
  return (
    <BrowserRouter>
      <Header />
      <Switch>
        <Route exact path="/" component={ Home } />
        <Route exact path="/filme/:id" component={ Filme } />
        <Route exact path="/favoritos" component={ Favoritos } />
        {/* Erro sempre por último */}
        <Route path="*" component={ NotFound } />
      </Switch>
    </BrowserRouter>
  )
}

export default Routes;